import * as React from "react"
import Svg, { Path } from "react-native-svg"
const ErrorBadge = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#E30513"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 4.5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6Zm1 12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
    />
  </Svg>
)
export default ErrorBadge
